import { createReducer } from 'redux-act';
import * as types from '../constants/ActionTypes';

const initialState = {
  text: null,
  color_banner: '#FFFFFF',
  color_topic: '#0D69F2'
};

const banner = createReducer(
  {
    [types.SET_BANNER]: (state, payload) => ({
      ...state,
      ...payload
    })
  },
  initialState
);

export default banner;



// WEBPACK FOOTER //
// ./src/reducers/banner.js